import React, {useEffect, useState} from "react";
import {getEglise} from "../misc/api";
import {useSelector} from "react-redux";
import ListPlaceByCommune from "./sub/ListPlaceByCommune";
import {useHistory} from "react-router-dom";

function ChoixEglise( props ) {

    let history = useHistory();

    const [ listeEglise, setListeEglise ] = useState( [] );

    const coordonnee = useSelector( ( state ) => state.coordonnee );

    const getAroundEglise = () => {
        getEglise( coordonnee.longitude, coordonnee.latitude, 10 )
            .then( response => {
                if( response.success ){
                    setListeEglise( response.data )
                }
            })
            .catch( error => console.log( error ) );
    }

    useEffect( getAroundEglise, []);

    return (
        <>
            <ListPlaceByCommune liste={ listeEglise } setpoi={ history.location.state } />
        </>
    );

}

export default ChoixEglise;